export default class LanguageValueObj {
  constructor() {
    this.map = new Map();
    this.value="value";
    this.lang="language";
  }

  addLang(lang) {
    this.map.set(lang, "");
  }

  removeLang(lang) {
    if (this.map.has(lang)) {
      this.map.delete(lang);
    }
  }

  setValue(lang, value) {
    this.map.set(lang, value);
  }

  getValue(lang) {
    return this.map.has(lang)?this.map.get(lang):"";
  }

  containsLang(lang) {
    return this.map.has(lang);
  }

  getExpandedFormatValue() {
    const list2return=[];
    for (const [lang, value] of this.map) {
      list2return.push({[this.lang]: lang, [this.value]: value});
    }
    return list2return;
  }

  parseInputJSON(inputJSON, objKey) {
    const obj=inputJSON[objKey];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value=entry[1];
        this.setValue(value[this.lang], value[this.value]);
      }
    } else {
      this.setValue(obj[this.lang], obj[this.value]);
    }
  }

  parseJsonObj(jsonObj) {
    if (jsonObj && jsonObj.language && jsonObj.value) {
      this.setValue(jsonObj.language, jsonObj.value);
    } else {
      console.warn('Invalid JSON object:', jsonObj);
    }
  }

  toJSON() {
    const jsonArray = [];
    for (const [lang, value] of this.map) {
        jsonArray.push({
            [this.lang]: lang,
            [this.value]: value
        });
    }
    return jsonArray;
  }

  isEmpty(specificLang) {
    let condition=true;
    for (const [lang, value] of this.map) {
      if (specificLang&&specificLang===lang) {
        condition=condition&&!value;
      } else {
        condition=condition&&!value;
      }
    }
    return condition;
  }

  print() {
    for (const [key, value] of this.map.entries()) {
      console.log(key+" : "+value);
    }
  }
}
